export const environment = {
  production: true,
  staging:false,
  development:false,
  baseUrl: 'https://v1.mijnglobal.nl/v1',
};
